define(
    'dataSource/apiCallPollingInterface',['jquery', 'lodash', 'atn/atn'],
    function($, _, atn) {
        'use strict';

        function Polling(failbackFn, callbackFn, ajaxSettings, checkInterval, context) {
            this.failbackFn = failbackFn;
            this.callbackFn = _.isFunction(callbackFn) ? callbackFn : _.noop;
            this.callPoll = false;
            this.ajaxSettings = ajaxSettings;
            this.checkInterval = checkInterval * 1000;
            if(context){
                this.context = context;
            }
        }

        Polling.prototype.start = function() {
            this.callPoll = true;
            this.reInitPoll();
        };

        Polling.prototype.stop = function() {
            this.callPoll = false;
        };

        Polling.prototype.pollOnce = function() {
            var self = this;
            var ajaxSettings = self.ajaxSettings;
            $.ajax(ajaxSettings).done(function(response) {
                self.onNotFail(response);
            }).fail(function(xhr) {
                if (xhr.status !== 0) {
                    self.onFail(xhr);
                } else {
                    self.onNotFail();
                }
            });
        };

        Polling.prototype.onNotFail = function(response) {
            if (this.callPoll) {
                this.callbackFn(response, this.context);
                this.reInitPoll();
            }
        };

        Polling.prototype.onFail = function(xhr) {
            if (this.callPoll) {
                this.failbackFn(xhr, this.context);
            }
        };

        Polling.prototype.reInitPoll = function() {
            var self = this;
            _.delay(function() {
                self.pollOnce();
            }, self.checkInterval);
        };

        return {
            createPolling: createPolling
        };

        function createPolling(failbackFn, callbackFn, ajaxSettings, checkInterval, context) {
            var poller = new Polling(failbackFn, callbackFn, ajaxSettings, checkInterval, context);
            return poller;
        }
    }
);
